import mixins from 'synergycms_core/src/less/mixins';

export default {
  defaultStyle: {
    minHeight:'calc(100vh - 29px)',
    display:'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    '@media(min-width:901px)':{
      minHeight:'calc(100vh - 62px)',
    },
    '& ul': {
      listStyle: 'none'
    }
  },
  mainContainer: {
    overflow: 'hidden',
    maxWidth: '1190px',
    margin: '0 auto',
    padding: '20px 10px 170px',
    width:'100%',
    boxSizing:'border-box',
    '@media (min-width: 801px), print': {
      padding: '20px 15px 100px'
    },
    '@media (min-width: 901px), print': {
      padding: '20px 0 100px'
    }
  },
  serviceContainer: {
    float: 'left',
    width: '64%',
    padding: '0 10px',
    ...mixins.boxSizing('content-box !important'),
    '& > ul': {
      margin: 0,
      padding: 0,
      '& > li': {
        font: data => '300 13px ' + data.fontFamily1,
        marginBottom: '10px',
        backgroundColor: '#fff',
        border: '0.5px solid #d8d8d8'
      }
    },
    '& > div:first-of-type': {
      padding: '10px 0',
    },
    '@media (max-width: 900px)': {
      width: 'auto',
      float: 'none',
      padding: '0'
    },
    '&:lang(ar)':{
      float:'right',
      direction:'rtl'
    }
  },
  summaryContainer: {
    ...mixins.boxSizing('content-box !important'),
    display: 'block',
    float: 'right',
    width: '31%',
    padding: '0 10px',
    '& > div': {
      position: 'fixed',
      left: '0px',
      top: '0',
      right: '0',
      bottom: '0',
      overflow: 'auto',
      background: '#fff',
      display: 'none',
      zIndex: '200',
      '@media (min-width: 901px), print': {
        position: 'static',
        display: 'block !important',
        border: '0.5px solid #d8d8d8'
      }
    },
    '@media (max-width: 900px)': {
      position: 'fixed',
      top: '0',
      right: '100%',
      zIndex: '200'
    },
    '&:lang(ar)':{
      float:'left',
      direction:'rtl',
      '@media (max-width: 900px)': {
        right:'auto',
        left:'100%'
      }
    }
  }
};
